module.exports = __webpack_public_path__ + "static/media/all-courses2.694096e4.svg";